import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {IRole} from "@models/roles/roles.ts";
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {ToDateTimeDefault} from "@shared/MathHelp.ts";
import {UsuarioTypo} from "@components/usuario/UsuarioTypo.tsx";
import {useRoles} from "@components/roles/hooks/useRoles.ts";

interface RoleInfoListProps extends DefaultInfoV1Props<IRole | number> {
}

export function RoleInfoList(props: RoleInfoListProps) {
    const {EndComponent} = props
    const {getRole} = useRoles()
    const [value, setValue] = useState<IRole | undefined>()

    useEffect(() => {
        if (typeof props.value == 'number') {
            getRole({data: {id: props.value}}).then(x => {
                setValue(x.items)
            })
        } else {
            setValue(props.value)
        }
    }, [props.value]);

    return (value != null &&
        <Grid container spacing={0.5}>
            <Typography>{value.id}</Typography>
            <Typography>{value.nome}</Typography>
            <Typography>{value.descricao}</Typography>
            <Typography>{ToDateTimeDefault(value.dataCriacao)}</Typography>
            <Typography component={'span'}>
                <UsuarioTypo usuarioId={value.usuarioCriacaoId}
                             typographyProps={{fontSize: 'smaller'}}/>
            </Typography>
            <Typography>{EndComponent && <EndComponent {...value}/>}</Typography>
        </Grid>
    )
}